import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import MessageBox from 'Components/Utility/MessageBox';

const errors = defineMessages({
  E000: { id: 'steam-E000', defaultMessage: 'Unexpected Error - Please try again' },
  E001: { id: 'steam-E001', defaultMessage: 'Error generating steam login link' },
  E002: { id: 'steam-E002', defaultMessage: 'Error validating steam callback' },
  E003: { id: 'steam-E003', defaultMessage: 'Invalid Steam callback url' },
  E004: { id: 'steam-E004', defaultMessage: 'Steam callback url expired' },
  E005: { id: 'steam-E005', defaultMessage: 'Steam account already linked to Fanatical account with email: {steamExistingEmail}' },
  E006: { id: 'steam-E006', defaultMessage: 'Error unlinking steam' },
  E007: { id: 'steam-E007', defaultMessage: 'Error refreshing steam' },
  E008: { id: 'steam-E008', defaultMessage: 'Could not refresh, steam is not connected' },
  E009: { id: 'steam-E009', defaultMessage: 'Unexpected error setting sync settings' },
  E010: { id: 'steam-E010', defaultMessage: 'Unexpected error performing manual sync' },
});

const SteamError = ({ error, intl, closeFunction }) => {
  if (!error) {
    return false;
  }

  const { formatMessage } = intl;

  let message = formatMessage(errors.E000);

  if (errors[error.code]) {
    message = formatMessage(errors[error.code], { steamExistingEmail: error.steamExistingEmail });
  }

  return (
    <MessageBox
      dismissible
      message={message}
      supportLink={360000365609}
      type="error"
      closeFunction={closeFunction}
    />
  );
};

export default injectIntl(SteamError);

SteamError.propTypes = {
  error: PropTypes.shape({
    code: PropTypes.string,
  }),
  closeFunction: PropTypes.func,
};

SteamError.defaultProps = {
  error: null,
};
